// Values taken from the Essity Brand World page supplied for this project.
export const essityBrand = {
  navy: '#00005A',
  pink: '#F50082',
  neutral: '#F7F5F5',
  border: '#C6CDD4',
  white: '#FFFFFF',
} as const;

// UI-only tones chosen to meet WCAG AA contrast (branding.instructions.md section 13); not official Essity values.
// TODO: Replace with approved Essity Brand World value.
export const essityUiTones = {
  // Pink for text and fills on light surfaces: 5.8:1 on white, 5.4:1 on neutral.
  pinkOnLight: '#C60067',
  // Hover and selected background on light surfaces; navy text on it is 15.6:1.
  pinkTint: '#FCE7F2',
  // Pink for text and indicators on dark surfaces: 6.2:1 on #1E1E1E.
  pinkOnDark: '#FF66B2',
} as const;

// Existing application status colours, shared by every theme.
export const essityStatus = {
  error: '#EF4444',
  warning: '#F59E0B',
  success: '#10B981',
} as const;

// Info stays blue in every theme so it is not mistaken for the pink accent.
export const essityStatusInfo = { light: '#1C4E80', dark: '#60A5FA' } as const;

export const essityStatusSurface = {
  light: { error: '#FFCDD2', warning: '#FFECB3', info: '#BBDEFB' },
  dark: { error: '#442C2C', warning: '#4A3D29', info: '#243447' },
} as const;

// Hover and divider overlay on dark surfaces.
export const essityOverlayOnDark = 'rgba(255, 255, 255, 0.12)';

// Existing application greys for the two dark themes.
export const essityDarkSurface = {
  default: '#121212',
  paper: '#1E1E1E',
} as const;
export const essityDarkIceSurface = {
  default: '#181818',
  paper: '#282828',
} as const;
